import React, { useEffect, useState } from 'react';
import '../styles/Description.css';
import BASE_URL from '../config';
// Mock data as fallback
const mockTour = {
  Title: 'Amazing Paris Adventure',
  NumberOfDays: 7,
  NumberOfNights: 6,
  TourCategory: 'Adventure',
  Description: 'Explore the breathtaking landscapes of New Zealand, from Lake Tekapo to the Earth and Sky observatory. Enjoy thrilling activities and unforgettable sights.',
};

const Description = () => {
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/api/tour`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        setTour(data);
        setLoading(false);
      })
      .catch(() => {
        setTour(mockTour);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!tour) return null;

  const {
    Title = '',
    NumberOfDays,
    NumberOfNights,
    TourCategory = '',
    Description: story = '',
  } = tour;

  // Format days as "7D/6N" if NumberOfDays and NumberOfNights are available
  const daysText = NumberOfDays && NumberOfNights ? `${NumberOfDays}D/${NumberOfNights}N` : '';

  // Split title into first word and the rest for highlight
  const words = Title.split(' ');
  const firstWord = words.shift();
  const restTitle = words.join(' ');

  return (
    <div className="tour-description" style={{ margin: '20px' }}>
      <div className="tour-page-intro-content">
        <div className="tour-page-intro-data-first">{daysText}</div>
        <div className="tour-page-intro-data">{TourCategory}</div>
      </div>
      <h2 >
        <span>{firstWord} </span>
        <span className="tour-title-highlight">{restTitle}</span>
      </h2>
      <p className="tour-description-part">{story}</p>
    </div>
  );
};

export default Description;
